import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Button, Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ModalTitle } from 'components/index';

import styles from './NewFolderDialog.module.scss';

type Props = {
  defaultFileName: string;
  onConfirm: (newName: string) => void;
  onCancel: () => void;
};

const NewFolderDialog = ({ defaultFileName, onConfirm, onCancel }: Props) => {
  const { t } = useTranslation('settings');
  const [value, setValue] = useState(defaultFileName);

  return (
    <Dialog open onClose={onCancel} className={styles.dialog}>
      <DialogTitle>
        <ModalTitle title={t('dialogs.createFolderTitle')} onClose={onCancel} />
      </DialogTitle>

      <DialogContent>
        <Typography variant='body2' component='p' sx={{ mb: 1 }}>
          {t('dialogs.enterNewFolderName')}
        </Typography>

        <TextField
          fullWidth
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          variant='outlined'
          sx={{ mb: 2 }}
        />

        <Stack direction='row' alignItems='center' className={styles.actionsRow}>
          <Button variant='outlined' fullWidth className={styles.formButton} onClick={onCancel}>
            {t('manageAccess.cancel')}
          </Button>
          <Button variant='contained' fullWidth className={styles.formButton} onClick={() => onConfirm(value)}>
            {t('manageAccess.save')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default NewFolderDialog;
